import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { ConfiguratorMainPanelComponent } from "./configurator-main-panel/configurator-main-panel.component";
import { ConfiguratorSummaryComponent } from "./configurator-summary/configurator-summary.component";
import { RouteGuard } from "src/app/core/route-guards/route-guard.guard";
import { DeploymentListComponent } from "../../deployment/components/deployment-list/deployment-list.component";
import { StorageListComponent } from "../../storage/components/storage-list/storage-list.component";
import { DeploymentSettingComopnent } from "../../deployment/components/deployment-setting/deployment-setting.component";
import { StorageSettingComponent } from "../../storage/components/storage-setting/storage-setting.component";
import { SynchpcConfigureComponent } from "../../synchpc/components/synchpc-setting/synchpc-configure.component";
import { UserRoleNames } from "src/app/core/models/users";
import { GatewayListComponent } from "../../gateway/components/gateway-list/gateway-list.component";
import { ListNodeConfiguratorComponent } from "./node-configurator/list-node-configurator/list-node-configurator.component";
import { AddNodeConfiguratorComponent } from "./node-configurator/add-node-configurator/add-node-configurator.component";
import { ThemeConfigComponent } from "./theme-config/theme-config.component";
import { CredentialListComponent } from "../../credential/credential-list/credential-list.component";
import { ImagesListComponent } from "../../images/images-list/images-list.component";
import { ActionConfirmComponent } from "../../session/components/action-confirm/action-confirm.component";
import { ActionLogsComponent } from "../../shared/components/actionlogs-component/action-logs.component";
import { LogViewerComponent } from "../../synchpc/components/log-viewer/log-viewer.component";
import { HealthComponent } from "../../health/health.component";
import { EntitySettingComponent } from "../../entity-setting/entity-setting.component";
import { GpoListComponent } from "./gpo-list/gpo-list.component";
import { SynchpcLicenseInfoComponent } from "../../synchpc/components/synchpc-license-info/synchpc-license-info.component";
import { DbServerInfoComponent } from "../../health/db-server-info/db-server-info.component";
import { HaConfigComponent } from "./ha-config/ha-config.component";

const routes: Routes = [
  {
    path: "Configurator",
    component: ConfiguratorMainPanelComponent,
    canActivate: [RouteGuard],
    canActivateChild: [RouteGuard],
    data: {
      role: [
        UserRoleNames.GlobalAdmin,
        UserRoleNames.PowerUser,
        UserRoleNames.DeploymentAdmin,
      ],
    },
    children: [

      { path: "Overview", component: ConfiguratorSummaryComponent },
      { path: "Deployment", component: DeploymentListComponent },
      {
        path: "Deployment/:cloudType/:deploymentName/settings",
        component: DeploymentSettingComopnent,
      },
      { path: "Storage", component: StorageListComponent },
      {
        path: "Storage/:cloudType/:deploymentName/:storageName/settings",
        component: StorageSettingComponent,
      },
      { path: "SyncHPC Settings", component: SynchpcConfigureComponent },
      
      { path: "Node Configuration", component: ListNodeConfiguratorComponent },
      { path: "Credentials", component: CredentialListComponent },
      { path: "Images", component: ImagesListComponent },
      {
        path: "Gateway",
        component: GatewayListComponent,
      },
      { path: "AddNodeConfig", component: AddNodeConfiguratorComponent },
      { path: "Activity Logs", component: ActionLogsComponent },
      { path: "Theme", component: ThemeConfigComponent },
      {
        path: "Billing",
        loadChildren: () =>
          import("./billing-configuration/billing-configuration.module").then(
            (m) => m.BillingConfigurationModule
          ),
      },
      { path: "SyncHPC Logs", component: LogViewerComponent },
      { path: "Health", component: HealthComponent },
      { path: "Group Policy", component: GpoListComponent },
      { path: "Entity Setting", component: EntitySettingComponent },
      { path: "SyncHPC License", component: SynchpcLicenseInfoComponent },
        { path: "Database Server", component: DbServerInfoComponent },
        { path: "HA Configuration", component: HaConfigComponent },
      { path: "", redirectTo: "Overview", pathMatch: "full" },
      
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class ConfiguratorRoutingModule {}
